module.exports = __webpack_public_path__ + "static/media/cobalt.ae5aa154.svg";